import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Seo from "@/components/Seo";
import { PILLARS, PILLAR_LIST, PILLAR_SITE, buildPillarJsonLd } from "@/lib/pillarContent";
import {
  PillarHeader, PillarHero, PillarArticle, PillarFaq, PillarCta, PillarRelated, PillarFooter,
} from "@/components/pillar/PillarSections";

export default function PillarPage({ slug }) {
  const navigate = useNavigate();
  const p = PILLARS[slug];
  const goTest = () => navigate("/test");

  if (!p) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center bg-[#fafafa] text-[#1a2d56] gap-4">
        <p className="font-head text-2xl">Page introuvable</p>
        <button onClick={() => navigate("/")} className="text-[#4b5b7c] underline">Retour à l'accueil</button>
      </div>
    );
  }

  const others = PILLAR_LIST.filter((x) => x.slug !== slug);

  return (
    <div className="min-h-screen bg-[#fafafa] text-[#4b5b7c]" data-testid={`pillar-${slug}`}>
      <Seo
        title={p.title}
        description={p.description}
        canonical={`${PILLAR_SITE}/${p.slug}`}
        jsonLd={buildPillarJsonLd(p)}
      />
      <PillarHeader navigate={navigate} goTest={goTest} />
      <PillarHero p={p} navigate={navigate} goTest={goTest} />

      <main className="max-w-3xl mx-auto px-6 py-16 md:py-24">
        <PillarArticle sections={p.sections} />
        <PillarFaq faqs={p.faqs} />
        <PillarCta goTest={goTest} />
        <PillarRelated others={others} navigate={navigate} />

        <button onClick={() => navigate("/")} data-testid="pillar-back-home"
          className="mt-12 inline-flex items-center gap-2 text-[#4b5b7c] font-semibold hover:text-[#1a2d56]">
          <ArrowLeft size={18} /> Retour à l'accueil
        </button>
      </main>

      <PillarFooter />
    </div>
  );
}
